import React from 'react';
import { useTranslation } from 'next-i18next';
import styles from './index.module.less';
import { CardIcon1, CardIcon2, CardIcon3, CardIcon4 } from './icons';

// 设计稿 #10899:3724 ~ #10899:3759，四张卡各自一套底色 / 描边
const CARDS = [
  {
    tone: 'blue',
    Icon: CardIcon1,
    title: '20% Commission, No Minimum Payout',
    desc: 'Earn 20% of what each referred customer pays, with no minimum payout.',
  },
  {
    tone: 'purple',
    Icon: CardIcon2,
    title: '30% Off for Referrals, Easier to Convert',
    desc: 'Your referrals get 30% off their first month, making the first subscription an easier decision.',
  },
  {
    tone: 'amber',
    Icon: CardIcon3,
    title: '97%+ Takedown Success Rate, Commission on Renewals',
    desc: 'If a referred customer renews, you keep earning commission for up to 6 months.',
  },
  {
    tone: 'green',
    Icon: CardIcon4,
    title: 'Free Trial, See Results First',
    desc: 'A free leak scan + takedown trial lets creators see the results before subscribing, making the decision easier.',
  },
] as const;

/** Why Erasa Is Easier to Recommend：设计稿 #10899:3719 */
const WhyErasa: React.FC<{ isModal?: boolean }> = ({ isModal = false }) => {
  const { t } = useTranslation('common');
  // 弹窗内整体下沉一级，避免与宿主页面的标题层级冲突
  const SectionHeading = isModal ? 'h3' : 'h2';
  const CardHeading = isModal ? 'h4' : 'h3';

  return (
    <section className={styles.container}>
      <div className={styles.inner}>
        {/* #10899:3721 */}
        <SectionHeading className={styles.title}>{t('Why Erasa Is Easier to Recommend')}</SectionHeading>

        {/* #10899:3723 */}
        <ul className={styles.cards}>
          {CARDS.map((card) => (
            <li key={card.tone} className={`${styles.card} ${styles[card.tone]}`}>
              <div className={styles.cardBody}>
                <span className={styles.icon}>
                  <card.Icon />
                </span>
                <CardHeading className={styles.cardTitle}>{t(card.title)}</CardHeading>
                <p className={styles.cardDesc}>{t(card.desc)}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default WhyErasa;
